import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-construction',
  templateUrl: './page-construction.component.html',
  styleUrls: ['./page-construction.component.scss']
})
export class PageConstructionComponent implements OnInit {

  mobile = false;
  scrollDistance: number;
  windowSize = { h: window.innerHeight, w: window.innerWidth };
  hideFooter = false;
  menuResize = false;
  enableMenuScroll = false;
  enableMobileIcon = false;
  rotaCurrent = '';
  titleName = '';

  links = {
     quem_somos: 'Quem somos',
     os_especialistas: 'Os especialistas',
     termos_condicoes: 'Termos e condições',
     politicas_comprador: 'Políticas do comprador',
     politicas_vendedor: 'Políticas do vendedor',
     ajuda: 'Ajuda',
     perguntas_frequentes: 'Perguntas frequentes',
     contato: 'Contato',
  }

  constructor( private router: ActivatedRoute) { }

  ngOnInit(): void {
    this.titleName = this.links[window.location.pathname.replace('/', '').replace('-', '_')];
  }

}
